
export default function Footer() {
    return (
        <footer className="text-center card-footer p-4 mt-5 footer">
            Made by <a
                className="text-white-50"
                target="_blank" rel="noreferrer"
                href="https://github.com/Tom-the-Bomb"
            >Tom-the-Bomb</a> 2023
        </footer>
    );
}